import { render, staticRenderFns } from "./UserAvailability.vue?vue&type=template&id=5bf0e0ec"
import script from "./UserAvailability.vue?vue&type=script&lang=ts"
export * from "./UserAvailability.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports